import { DateTime } from 'luxon';
import { LocalDate } from './datePicker/types';

// Costura entre el Date/Luxon del resto de la app y el LocalDate puro del
// picker (CX-638). Vive en model/, no en model/datePicker/, porque ese
// módulo evita `Date`/Luxon a propósito — esto es exactamente el punto de
// cruce entre los dos mundos, compartido entre la capa de UI y la de query.
const toLocalDate = (d: Date): LocalDate => DateTime.fromJSDate(d).toFormat('yyyy-MM-dd') as LocalDate;

const toJsDate = (d: LocalDate, edge: 'start' | 'end'): Date => {
  const dt = DateTime.fromISO(d);
  return (edge === 'start' ? dt.startOf('day') : dt.endOf('day')).toJSDate();
};

export { toLocalDate, toJsDate };
